"use client";

import type { ReactNode } from "react";
import type { Route } from "next";
import Link from "next/link";
import useNavigationStack from "../useNavigationStack";

interface Props<R extends string> {
  defaultUrl: Route<R>;
  className?: string;
  children: ReactNode;
}

export default function BackButton<R extends string>({ defaultUrl, children }: Props<R>) {
  const { pop } = useNavigationStack();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    pop(defaultUrl);
  };

  return (
    <Link href="#" onClick={handleClick}>
      {children}
    </Link>
  );
}
